import BaseAxios from '../services/api/BaseApi';

export const configureAxios = (token: string) => {
  // axios.defaults.baseURL = "https://dev.gp7.digital";
  // axios.defaults.headers.common.Authorization = `Bearer ${token}`;

  BaseAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
};
